<div class="d-flex align-items-center ms-1 ms-lg-3">
    <button pButton class="btn btn-sm btn-primary" (click)="show()">
        {{ appSession.user.locationCode ? appSession.user.locationCode : 'Select' }}
    </button>
</div>

<p-dialog
    header="User: {{ appSession.user.userName }} - Select Location"
    [(visible)]="display"
    [modal]="true"
    [style]="{ width: '700px' }"
    [closable]="true"
>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group m-form__group">
                <label for="CompanyName">{{ l('Company') }}</label>
                <select name="selectedCompanyId" [(ngModel)]="selectedCompanyId" class="form-select">
                    <option value="">{{ l('SelectACompany') }}</option>

                    <option *ngFor="let item of allCompanys" value="{{ item.id }}">
                        {{ item.displayName }}
                    </option>
                </select>
            </div>
        </div>
    </div>
    <div class="row align-items-center">
        <div class="col-xl-12">
            <div class="my-3">
                <div class="input-group mb-3">
                    <input
                        [(ngModel)]="filterText"
                        (ngModelChange)="getLocations()"
                        name="filterText"
                        autoFocus
                        type="text"
                        class="form-control"
                        [placeholder]="l('SearchWithThreeDot')"
                    />
                    <button class="btn btn-primary" type="submit" (click)="getLocations()">
                        <i class="flaticon-search-1"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
        <p-table
            #dataTable
            (onLazyLoad)="getLocations($event)"
            [value]="primengTableHelper.records"
            rows="{{ primengTableHelper.defaultRecordsCountPerPage }}"
            [paginator]="false"
            tableStyleClass="table table-bordered table-hover"
            [lazy]="true"
            [scrollable]="true"
            ScrollWidth="100%"
            [tableStyle]="{ 'min-width': '50rem' }"
            [resizableColumns]="primengTableHelper.resizableColumns"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 5%">
                        {{ l('Actions') }}
                    </th>
                    <th style="width: 150px" pSortableColumn="code">
                        {{ l('Code') }}
                        <p-sortIcon field="location.code"></p-sortIcon>
                    </th>
                    <th style="width: 150px" pSortableColumn="name">
                        {{ l('Name') }}
                        <p-sortIcon field="location.name"></p-sortIcon>
                    </th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                <tr>
                    <td style="width: 5%">
                        <div class="btn-group dropdown" dropdown container="body">
                            <button class="btn btn-sm btn-primary" (click)="selectLocation(record.location)">
                                <i class="fa fa-check-circle"></i>
                            </button>
                        </div>
                    </td>
                    <td style="width: 150px">
                        <span class="p-column-title">{{ l('Code') }}</span>
                        {{ record.location.code }}
                    </td>
                    <td style="width: 150px">
                        <span class="p-column-title">{{ l('Name') }}</span>
                        {{ record.location.name }}
                    </td>
                </tr>
            </ng-template>
        </p-table>

        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
            {{ l('NoData') }}
        </div>

        <div class="primeng-paging-container">
            <p-paginator
                [rows]="primengTableHelper.defaultRecordsCountPerPage"
                #paginator
                (onPageChange)="getLocations($event)"
                [totalRecords]="primengTableHelper.totalRecordsCount"
                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                [showCurrentPageReport]="true"
                [currentPageReportTemplate]="'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount"
            ></p-paginator>
        </div>
    </div>
</p-dialog>
